import { IAPIContext } from 'models/context/api-context';
import { SSOAPIBaseError, SSOAPIBaseErrorOptions } from './sso-api-base-error';
import { ErrorMessageResponse } from 'models/schema-generated-models/api-response-bodies/error-message-response';

export class SSOAPIResponseError extends SSOAPIBaseError {
    protected apiContext: IAPIContext;
    constructor(apiContext: IAPIContext, message?: string, options?: SSOAPIBaseErrorOptions) {
        super(message, options);
        this.apiContext = apiContext;
    }

    public getAPIContext() {
        return this.apiContext;
    }
}

export class SSOAPINotFoundError extends SSOAPIResponseError {}
export class SSOAPIUnexpectedResponseBody extends SSOAPIResponseError {}
export class SSOAPIUnexpectedResponseStatus extends SSOAPIResponseError {}


export class SSOAPIParsedResponseError extends SSOAPIResponseError {
    protected responseError: ErrorMessageResponse;
    constructor(responseError: ErrorMessageResponse, apiContext: IAPIContext, message?: string, options?: SSOAPIBaseErrorOptions) {
        super(apiContext, message, options);
        this.responseError = responseError;
    }

    public getResponseError() {
        return this.responseError;
    }
}

export class SSOAPIServerError extends SSOAPIParsedResponseError {}
export class SSOAPIUserInsufficientPermissionsError extends SSOAPIParsedResponseError {}
export class SSOAPIUserSessionInvalidError extends SSOAPIParsedResponseError {}
export class SSOAPIBadRequest extends SSOAPIParsedResponseError {}


